<template>
    <tr class="thead-light">
        <th v-for="x in props.fields" :key="x.name" v-show="x.visible != false">
            
                <fieldhead :fieldobj="x" :defaultval="matchruledefault[x.name]" :defaultsortval="sortsetdefault[x.name]"
                    @fieldheadset="fieldheadset">
                </fieldhead>
                <!-- :disabled="x.filterable === 'no' && x.name != 'edit' && x.name != 'tick'" -->

           
        </th>
    </tr>
</template>
<script>
import fieldhead from "./table_header_fieldhead"
export default {
    components: { fieldhead },
    props: ["props", "sortsetdefault", "matchruledefault"],
    data() {
        return {
            matchrule: this.matchruledefault || {},
            sortset: this.sortsetdefault || {},
        }
    },
    computed: {
        // items() {
        //     return this.$store.state.items;
        // },
        // sortset() {
        //     return this.$store.state.sortset;
        // },
    },

    methods: {

        fieldheadset(obj) {
            // console.log(this.props)
            for (let key in obj.matchrule) {
                if (obj.matchrule[key] == "") {
                    delete this.matchrule[key]
                }
                else {
                    Object.assign(this.matchrule, obj.matchrule)
                }
            }

            for (let key in obj.sortset) {
                if (obj.sortset[key] == undefined) {
                    delete this.sortset[key]
                }
                else {
                    Object.assign(this.sortset, obj.sortset)
                }
            }


            this.$emit("headersetdone", { matchrule: this.matchrule, sortset: this.sortset, currentfield: obj.currentfield })
        },


    }
}
</script>


// WEBPACK FOOTER //
// src/components/presentation/table/table_header.vue